import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type Input = ApiDefinition['/creators/{creatorId}/last-viewed-dashboard-at']['PUT']['params'];

const creatorViewedDashboard = async ({ creatorId }: Input): Promise<void> => {
  await noodleApiClient.put(`/creators/${creatorId}/last-viewed-dashboard-at`);
};

export default creatorViewedDashboard;
